// extracted by mini-css-extract-plugin
export default {"note-view-content":"note-view-content---UxA6z","note-details-container":"note-details-container---c9tsi"};